import api from "./revenuePlannerApi";

const path = "/workflow-status";

const workflowStatus = {
  list: (accessToken) => api.get(path, accessToken),
  get: (accessToken, parent) => api.get(`${path}/${parent}`, accessToken),
  post: (accessToken, body) => api.post(path, body, accessToken),
  put: (accessToken, id, body) => api.put(`${path}/${id}`, body, accessToken),
  delete: (accessToken, id) => api.delete(`${path}/${id}`, accessToken),
};

export default workflowStatus;
